import * as yup from 'yup';

export const ForgotPasswordSchema = yup.object({
    email: yup.string().email('email_invalid').required('required'),
});
